import Vue from 'vue'
export default new Vue()



// WEBPACK FOOTER //
// ./src/lib/eventBus.js